import { useDispatch, useSelector } from "react-redux";

import constants from "../store/constants";

import { CLEANED_GENERATE_FORM } from "./instructions";

export function useGenerateReportForm(method) {
  const dispatch = useDispatch();

  const hasForm = useSelector((state) =>
    Boolean(state[constants.STORE_NAME].forms[method])
  );

  if (!hasForm) {
    dispatch({
      type: constants.INSERT_INTO_FORMS,
      payload: {
        result: CLEANED_GENERATE_FORM,
        name: "generate_form",
        method: method,
      },
    });
  }

  return hasForm;
}
